import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ShieldCheck } from "lucide-react";

// Compact badge designed to be embedded via <iframe> on a tenant's own website.
export default function VerifiedBadge() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("dark");
    document.body.style.background = "transparent";
    api.get(`/onboarding/verified/${slug}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return null;
  if (!data) return null;

  return (
    <a
      href={`/verified/${slug}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="verified-badge-embed"
      style={{ textDecoration: "none" }}
      className="block"
    >
      <div className="flex items-center gap-3 border border-border bg-card rounded-sm px-3.5 py-2.5 hover:border-accent transition-colors max-w-[260px]">
        <div className="h-9 w-9 rounded-sm bg-accent flex items-center justify-center shrink-0">
          <ShieldCheck className="h-5 w-5 text-black" strokeWidth={2.5} />
        </div>
        <div className="min-w-0">
          <div className="text-[9px] uppercase tracking-[0.16em] text-accent font-semibold">Verified by Lestari</div>
          <div className="font-display font-bold text-[13px] leading-tight truncate text-foreground">{data.name}</div>
          <div className="text-[10px] text-muted-foreground font-mono">
            ESG member{data.member_since ? ` since ${data.member_since}` : ""}
          </div>
        </div>
      </div>
    </a>
  );
}
